import {en} from "./translations.en";
import {fr} from "./translations.fr";

export const translations = {
  en: {
    onlineScreen: en,
  },
  fr: {
    onlineScreen: fr,
  },
};
